<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="fromCommercialisation" :confirm="askConfirm"
                    :params="{operationId: operationId, currentSectionId:currentSectionId}"
                    :title="operationName + ' - Planning'" route-back="CommercialisationLotsShow"/>
        <back-arrow v-else :confirm="askConfirm" :params="{operationId: operationId}"
                    :title="operationName + ' - Planning'" route-back="OperationShowPlanning"/>
      </div>

      <b-card class="my-3">
        <div class="mb-1">
          <b-container fluid>
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <span class="section-title">{{ $t('evenementPlanning.section.achat') }}</span>
                </div>
                <b-form-group
                  :label="$t(operation['SSP'].label)"
                  :label-for="operation['SSP'].type + '-input'"
                  class="col-md-3 medium-label mb-4">
                  <datepicker-input
                    :id="operation['SSP'].type + '-input'"
                    v-model="operation['SSP'].date"
                    v-on:change="askConfirm=true;"/>
                </b-form-group>

                <b-form-group
                  :label="$t(operation['ACTE_ACHAT'].label)"
                  :label-for="operation['ACTE_ACHAT'].type + '-input'"
                  class="col-md-3 medium-label mb-4">
                  <datepicker-input
                    :id="operation['ACTE_ACHAT'].type + '-input'"
                    v-model="operation['ACTE_ACHAT'].date"
                    v-on:change="askConfirm=true;"/>
                </b-form-group>

                <div class="col-md-12 mb-3 mt-4">
                  <span class="section-title">{{ $t('evenementPlanning.section.formalite') }}</span>
                </div>

                <b-form-group
                  :label="'Type de demande'"
                  class="col-md-3 medium-label mb-4"
                  label-for="operationDelayType-input">
                  <b-form-select
                    id="operationDelayType-input"
                    v-model="evenementDelayType">
                    <option v-for="option in typesEvenementsDelay" :value="option.value">
                      {{ $t(option.text) }}
                    </option>
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  :label="$t(operation['DEPOT_PC_DP'].label)"
                  :label-for="operation['DEPOT_PC_DP'].type + '-input'"
                  class="col-md-3 medium-label mb-4">
                  <datepicker-input
                    :id="operation['DEPOT_PC_DP'].type + '-input'"
                    v-model="operation['DEPOT_PC_DP'].date"
                    v-on:change="askConfirm=true;"/>
                </b-form-group>

                <b-form-group
                  :label="$t(operation['DEMANDE_PIECE_COMPLEMENTAIRE'].label)"
                  :label-for="operation['DEMANDE_PIECE_COMPLEMENTAIRE'].type + '-input'"
                  class="col-md-3 medium-label mb-4">
                  <datepicker-input
                    :id="operation['DEMANDE_PIECE_COMPLEMENTAIRE'].type + '-input'"
                    v-model="operation['DEMANDE_PIECE_COMPLEMENTAIRE'].date"
                    v-on:change="askConfirm=true;"/>
                </b-form-group>

                <b-form-group
                  :label="$t(operation['DEPOT_PIECE_COMPLEMENTAIRE'].label)"
                  :label-for="operation['DEPOT_PIECE_COMPLEMENTAIRE'].type + '-input'"
                  class="col-md-3 medium-label mb-4">
                  <datepicker-input
                    :id="operation['DEPOT_PIECE_COMPLEMENTAIRE'].type + '-input'"
                    v-model="operation['DEPOT_PIECE_COMPLEMENTAIRE'].date"
                    v-on:change="askConfirm=true;"/>
                </b-form-group>

                <b-form-group v-if="operation['ACCORD_PC_DP']"
                              :label="$t(operation['ACCORD_PC_DP'].label)"
                              :label-for="operation['ACCORD_PC_DP'].type + '-input'"
                              class="col-md-3 medium-label mb-4">
                  <b-input-group>
                    <datepicker-input
                      :id="operation['ACCORD_PC_DP'].type + '-input'"
                      v-model="operation['ACCORD_PC_DP'].date">
                    </datepicker-input>
                    <b-input-group-append>
                      <wand-icon class="cursor-pointer" @click="calculateAccordDate"></wand-icon>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div class="explication col-md-9">
                  <b-icon id="info-circle-expense" class="ml-2" icon="info-circle"
                  ></b-icon>
                  {{ $t('operationPlanning.operation.accord.pc.dp.explication') }}
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-container>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import api from "../../../src/services/api";
import BackArrow from "../../components/b122/BackArrow";
import EvenementCreateEditOperation from "./EvenementCreateEditOperation"
import EvenementCreateEditOperationLot from "./EvenementCreateEditOperationLot"
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: "OperationEvenementCreateEdit",
  components: {
    BackArrow,
    EvenementCreateEditOperationLot,
    EvenementCreateEditOperation,
    DatepickerInput
  },
  props: {},

  async mounted() {
    await this.fetchData()
    this.currentSection = 0
  },

  data() {
    return {
      operation: {},
      currentSection: null,
      lots: [],
      operationName: null,
      operationId: this.$route.params.operationId,
      fromCommercialisation: this.$route.params.fromCommercialisation,
      currentSectionId: this.$route.params.currentSectionId,
      typesEvenementsOperation: [],
      typesEvenementsDelay: [],
      askConfirm: false,
      evenementDelayType: null
    }
  },

  methods: {
    calculateAccordDate() {
      const depotDate = this.operation.DEPOT_PC_DP && this.operation.DEPOT_PC_DP.date ? new Date(this.operation.DEPOT_PC_DP.date) : null;
      const demandePieceComplementaireDate = this.operation.DEMANDE_PIECE_COMPLEMENTAIRE && this.operation.DEMANDE_PIECE_COMPLEMENTAIRE ? new Date(this.operation.DEMANDE_PIECE_COMPLEMENTAIRE.date) : null;
      const depotPieceComplementaireDate = this.operation.DEPOT_PIECE_COMPLEMENTAIRE && this.operation.DEPOT_PIECE_COMPLEMENTAIRE.date ? new Date(this.operation.DEPOT_PIECE_COMPLEMENTAIRE.date) : null;

      if (!depotDate || isNaN(depotDate.getTime())) {
        this.$set(this.operation.ACCORD_PC_DP, 'date', null);
        return;
      }

      let monthsToAdd = 0;
      const delayType = this.evenementDelayType;
      if (delayType) {
        const delayEnum = this.typesEvenementsDelay.find(item => item.value === delayType);
        if (delayEnum) {
          monthsToAdd = delayEnum.monthValue;
        }
      }

      let accordDate = new Date(depotDate);
      accordDate.setMonth(accordDate.getMonth() + monthsToAdd);


      if (demandePieceComplementaireDate && depotPieceComplementaireDate && !isNaN(demandePieceComplementaireDate.getTime()) && !isNaN(depotPieceComplementaireDate.getTime() && monthsToAdd > 0)) {
        accordDate = new Date(depotPieceComplementaireDate);
        accordDate.setMonth(accordDate.getMonth() + monthsToAdd);
      }

      this.$set(this.operation.ACCORD_PC_DP, 'date', accordDate.toISOString().split('T')[0]);
    },

    async fetchData() {
      if (this.operationId) {
        await this.fetchOperation()
      }
      await this.getTypesEvenements()
      await this.getEvenementTypesDelay()
      await this.fetchEvenements()
      this.$forceUpdate()
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
          this.evenementDelayType = response.data.evenementDelayType
        })
    },

    async getEvenementTypesDelay() {
      await api
        .get(`/evenementPlanning/getEvenementTypesDelay`)
        .then(response => {
          this.typesEvenementsDelay = response.data
        })
    },

    async getTypesEvenements() {
      await api
        .get(`/evenementPlanning/getCreateEvenementTypes`)
        .then(response => {
          response.data.forEach(typeEvenement => {
            if (typeEvenement.scope === 'operation') {
              this.typesEvenementsOperation.push(typeEvenement);
            }
          });
        })

      this.typesEvenementsOperation.forEach(type => {
        this.$set(this.operation, type.value, {
          id: null,
          type: type.value,
          label: type.text,
          date: null,
          realDate: null,
          operationId: this.operationId,
        });
      })
    },

    async fetchEvenements() {
      await api.get('/operation/getEvenementsPlanning/' + this.operationId).then((response) => {
        response.data.forEach(event => {
          if (event.operation) {
            if (!this.operation[event.event_type]) {
              this.$set(this.operation, event.event_type, {});
            }
            if (event.startEvent === undefined) {
              this.$set(this.operation[event.event_type], 'date', null);
            } else {
              this.$set(this.operation[event.event_type], 'date', new Date(event.startEvent).toLocaleDateString().split("/").reverse().join("-"));
            }
            this.$set(this.operation[event.event_type], 'realDate', event.realDate);
            this.$set(this.operation[event.event_type], 'id', event.id);
            if (event && (event.event_type === "DEPOT_PC_DP")) {
              this.$set(this.operation[event.event_type], 'evenementDelayType', event.evenementDelayType ? event.evenementDelayType : null);
            }
          }
        });
      });
    },

    didChangeValue() {
      this.askConfirm = true
    },

    async onSubmit() {
      await this.createOrUpdateEvents()
      await this.updateEvenementDelayType()
      if (this.fromCommercialisation) {
        await this.$router.push({
          name: 'CommercialisationLotsShow',
          params: {
            operationId: this.operationId,
            currentSectionId: this.currentSectionId
          }
        })
      } else {
        await this.$router.push({
          name: 'OperationShowPlanning',
          params: {
            operationId: this.operationId,
            currentSection: 5
          }
        })
      }

    },

    async updateEvenementDelayType() {
      let data = new FormData()

      data.append('evenementDelayType', this.evenementDelayType)
      await api({
        method: 'POST',
        url: '/operation/updateEvenementDelayType/' + this.operationId,
        data: data
      })
        .then(() => {

        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShowPlanning',
              params: {
                operationId: this.operationId,
                currentSection: 5,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async createOrUpdateEvents() {
      // Get all events of all operation and lots
      let allEvents = []
      for (const event in this.operation) {
        allEvents.push(this.operation[event])
      }

      // Save or update all
      for (const event in allEvents) {
        let data = new FormData()
        if (allEvents[event].date === 'null' || allEvents[event].date === null) {
          continue
        }
        if (allEvents[event].operationLotId != null) {
          data.append('operationLotId', allEvents[event].operationLotId)
        }
        if (allEvents[event].operationId != null) {
          data.append('operationId', allEvents[event].operationId)
        }
        data.append('date', allEvents[event].date)
        data.append('type', allEvents[event].type)
        data.append('realDate', allEvents[event].realDate)

        await api({
          method: 'POST',
          url: allEvents[event].id != null ? '/evenementPlanning/' + allEvents[event].id : '/evenementPlanning',
          data: data
        })
          .then(() => {

          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShowPlanning',
                params: {
                  operationId: this.operationId,
                  currentSection: 5,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },
  },
}
</script>


<style scoped>
.explication {
  color: var(--tertiary-text-color);
  font-size: 14px;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
  display: flex;
  justify-content: start;
  align-items: center;
}
svg[aria-label="info circle"] {
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/OperationEvenementCreateEdit.vue